function addIdListener(id, eventName) {
  const element = document.getElementById(id);
  if (element === null) {
    return;
  }
  element.addEventListener('click', () => {
    document.dispatchEvent(new CustomEvent(eventName));
  });
}

export default function registerModalClickEvents() {
  addIdListener('tour', 'openTourModal');
  addIdListener('reset-portlets-config', 'openResetPageLayoutModal');
}
